import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { CoreCommonModule } from "@core/common.module";

import { ContentHeaderModule } from "app/layout/components/content-header/content-header.module";

import { HomeComponent } from "./home.component";
import { AuthGuard } from "../../util/guard/auth.guard";
import { NgxBootstrapIconsModule } from "ngx-bootstrap-icons";
import { ComponentsModule } from "../../util/components/components.module";
import { HomeCardComponent } from "./partials/home-card/home-card.component";
import { HomeCollapsibleComponent } from "./partials/home-collapsible/home-collapsible.component";

const routes = [
  {
    path: "home",
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: {
      animation: "home",
    },
  },
];

@NgModule({
  declarations: [HomeComponent, HomeCardComponent, HomeCollapsibleComponent],
  imports: [
    RouterModule.forChild(routes),
    ContentHeaderModule,
    TranslateModule,
    CoreCommonModule,
    NgxBootstrapIconsModule,
    ComponentsModule,
  ],
  exports: [HomeComponent],
})
export class DashboardModule {}
